/* global CONFIG */
import moment from 'moment'
import ft from '../featureToggle'

export default {
  getRsvp (VueApp, param, callback) {
    let self = this
    let provider = VueApp.$store.state.provider
    let pageSize = provider.rsvpPerPage
    let page = provider.currentPage[param.type]
    let pickupSince = moment(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY')
    let pickupUntil = moment(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days')

    VueApp.$sdk.get('/provider/' + param.id + '/rsvp/' + param.type, {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1,
      pickupSince: pickupSince.format('YYYY-MM-DD'),
      pickupUntil: pickupUntil.format('YYYY-MM-DD')
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setCurrentPage', {
          type: param.type,
          page: page + 1
        })

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setIsMax', {
            type: param.type,
            isMax: true
          })
        }
        
        let gasFee = 0
        let tip = 0
        if (res.list.length) {
          // let newTotalDriverPayment = 0
          for (let i = 0; i < res.list.length; i++) {
            let buildData = (res.list[i].type === 'rsvp') ? self.buildRsvpData(VueApp, res.list[i].data) : self.buildPkgData(VueApp, res.list[i].data)

            // newTotalDriverPayment += buildData.amountPaid
            if (buildData !== false) {
              VueApp.$store.commit('provider/addRsvp', {
                type: param.type,
                rsvp: buildData
              })
            }
            if (res.list[i].type === 'rsvp') {
              gasFee += res.list[i].data.gasFee
              tip += res.list[i].data.payment.tip
            } else {
              res.list[i].data.rsvp.forEach(rsvp => {
                gasFee += rsvp.gasFee
                tip += rsvp.payment.tip
              })
            }
          }

          if (param.type === 'upcoming') {
            VueApp.$store.commit('provider/setTotalDriverPayment', {
              type: param.type,
              value: res.summary.payment + tip + gasFee
            })
          }
        }
      }
      callback(res)
    })
  },
  getTotalPayment (VueApp, param, callback) {
    VueApp.$sdk.get('/provider/' + param.id + '/earnings', {
      token: VueApp.$store.state.session.sessionToken,
      since: param.since,
      until: param.until
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setTotalDriverPayment', {
          type: param.type,
          value: (res.fare + res.bonus + res.tip + res.pickupFee + res.gasFee) - res.deductions
        })
      }
      callback(res)
    })
  },
  buildRsvpData (VueApp, data) {
    let customer = data.consumer.firstName + ' ' + data.consumer.lastName
    if (data.guest.firstName) {
      customer = data.guest.firstName + ' ' + data.guest.lastName
    }
    let flight = 'N/A'
    if (data.airline) { flight = data.airline + ' ' + data.flightNumber }
    if (!data.airline && data.dropoffAirline) { flight = data.dropoffAirline + ' ' + data.dropoffFlightNumber }
    let payment = data.payment
    let amount = payment.amount + data.gasFee + payment.bonus + payment.tip + payment.pickupFee
    let hudsonId = data.externalId

    let pickup = data.pickupLocation.geofenceType === 'airport' ? data.pickupLocation.geofenceName : data.pickupLocation.title
    let dropoff = data.dropoffLocation.geofenceType === 'airport' ? data.dropoffLocation.geofenceName : data.dropoffLocation.title

    let rsvpData = {
      id: data.ID,
      type: 'rsvp',
      pickupTime: moment(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickup: pickup,
      dropoff: dropoff,
      service: data.serviceType.code,
      customer: customer,
      pax: data.passengers,
      luggage: data.luggage,
      flight: flight,
      amountPaid: amount,
      hudsonId: hudsonId,
      isCharter: data.isCharter
    }
    if (!CONFIG.useOldQuatation) {
      rsvpData.serviceType = {
        label: data.serviceType.label,
        color: data.serviceType.color
      }
    }
    return rsvpData
  },
  buildPkgData (VueApp, data) {
    let customer = data.rsvp[0].consumer.firstName + ' ' + data.rsvp[0].consumer.lastName
    if (data.rsvp[0].guest.firstName) {
      customer = data.rsvp[0].guest.firstName + ' ' + data.rsvp[0].guest.lastName
    }
    let luggage = 0
    let gasFee = 0
    let tip = 0
    for (let i = 0; i < data.rsvp.length; i++) {
      luggage = luggage + data.rsvp[i].luggage
      gasFee += data.rsvp[i].gasFee
      tip += data.rsvp[i].payment.tip
    }
    let index = data.rsvp.findIndex(x => x.ID === data.stops[data.stops.length - 1].reservationID)

    if (data.rsvp.length === 0) { return false }

    let pkgData = {
      id: data.package.id,
      type: 'pkg',
      pickupTime: moment(data.package.pickupTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickup: data.package.firstPickup,
      dropoff: data.rsvp[index].dropoffLocation.city,
      service: 'shared',
      customer: customer,
      pax: data.package.pax,
      luggage: luggage,
      flight: 'N/A',
      amountPaid: data.package.paidForProvider + gasFee + tip
    }
    if (!CONFIG.useOldQuatation) {
      pkgData.serviceType = {
        label: data.rsvp[0].serviceType.label,
        color: data.rsvp[0].serviceType.color
      }
    }
    return pkgData
  },
  getAllRsvp (VueApp, param, callback) {
    let provider = VueApp.$store.state.provider
    let pickupSince = moment(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY')
    let pickupUntil = moment(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days')

    VueApp.$sdk.get('/provider/' + param.id + '/rsvp/' + param.type, {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: 999,
      pageNum: 1,
      pickupSince: pickupSince.format('YYYY-MM-DD'),
      pickupUntil: pickupUntil.format('YYYY-MM-DD')
    }, res => {
      if (!res.error) {
        let payments = []

        let deductions = VueApp.$store.state.provider.breakdown.deductions

        for (let i = 0; i < res.list.length; i++) {
          if (res.list[i].type === 'rsvp') {
            let breakdownObject = {
              amount: res.list[i].data.bonus.basePay,
              gasFee: res.list[i].data.gasFee,
              bonusAmount: res.list[i].data.bonus.amount || 0,
              releaseBonus: res.list[i].data.payment.bonus || 0,
              pickupFee: res.list[i].data.payment.pickupFee || 0,
              tip: res.list[i].data.payment.tip || 0,
              deductions: 0,
              type: 'RSVP',
              id: res.list[i].data.ID
            }
            if (!res.list[i].data.bonus.basePay) {
              breakdownObject.amount = res.list[i].data.payment.amount
            }
            let deductionIndex = deductions.findIndex(x => x.id === res.list[i].data.ID && x.type === 'RSVP')
            if (deductionIndex > -1) {
              breakdownObject.deductions = deductions[deductionIndex].deductions
              deductions.splice(deductionIndex, 1)
              VueApp.$store.commit('provider/setProviderBreakdown', {
                value: deductions,
                type: 'deductions'
              })
            }
            VueApp.$store.commit('provider/addProviderBreakdown', {
              type: param.type,
              value: breakdownObject
            })
          } else {
            let breakdownObject = {
              amount: 0,
              gasFee: 0,
              bonusAmount: 0,
              releaseBonus: 0,
              pickupFee: 0,
              tip: 0,
              deductions: 0,
              type: 'PKG',
              id: res.list[i].data.package.id
            }
            res.list[i].data.rsvp.forEach(function (data) {
              breakdownObject.pickupFee += parseFloat(data.payment.pickupFee) || 0
              breakdownObject.tip += parseFloat(data.payment.tip) || 0
              breakdownObject.gasFee += parseFloat(data.gasFee) || 0
              if (data.bonus.amount) {
                breakdownObject.bonusAmount += parseFloat(data.bonus.amount) || 0
              }
              if (data.payment.bonus) {
                breakdownObject.releaseBonus += parseFloat(data.payment.bonus) || 0
              }
            })
            breakdownObject.amount = parseFloat(res.list[i].data.package.paidForProvider) || 0
            // breakdownObject.bonus = parseFloat(res.list[i].data.package.bonusToProvider) || 0
            let deductionIndex = deductions.findIndex(x => x.id === res.list[i].data.package.id && x.type === 'PKG')
            if (deductionIndex > -1) {
              breakdownObject.deductions = deductions[deductionIndex].deductions
              deductions.splice(deductionIndex, 1)
              VueApp.$store.commit('provider/setProviderBreakdown', {
                value: deductions,
                type: 'deductions'
              })
            }
            VueApp.$store.commit('provider/addProviderBreakdown', {
              type: param.type,
              value: breakdownObject
            })
          }
        }
        // VueApp.$store.commit('provider/addProviderBreakdown', {
        //   value: payments,
        //   type: param.type
        // })
      }

      callback(res)
    })
  },
  getDeductions (VueApp, param, callback) {
    let provider = VueApp.$store.state.provider
    let pickupSince = moment(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY')
    let pickupUntil = moment(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days')

    VueApp.$sdk.get('/provider/' + param.id + '/deductions', {
      token: VueApp.$store.state.session.sessionToken,
      since: pickupSince.format('YYYY-MM-DD'),
      until: pickupUntil.format('YYYY-MM-DD')
    }, res => {
      if (!res.error) {
        let deductions = []
        res.list.forEach(function (data) {
          deductions.push({
            amount: 0,
            bonusAmount: 0,
            releaseBonus: 0,
            pickupFee: 0,
            tip: 0,
            gasFee: 0,
            type: data.rsvpId ? 'RSVP' : 'PKG',
            id: data.rsvpId || data.packageId,
            deductions: data.cancelFee
          })
        })
        VueApp.$store.commit('provider/setProviderBreakdown', {
          value: deductions,
          type: 'deductions'
        })
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/reservations.js